module.exports = "/images/audit-log-black.svg?c4d0543ba6f9cec6afaec6cdce6c0aa3";